import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { minWidth, width } from '@mui/system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chatBox: {
      zIndex: '999 !important',
      // left: '58% !important',
      // top: '38% !important',
      '@media (max-width:600px)': {
        left: '0 !important',
        top: '25% !important',
      },
    },
    viewMoreLess: {
      color: '#6A4EA6',
      cursor: 'pointer',
      fontSize: '12px',
      marginLeft: '5px',
    },
    dialogPaper: {
      borderRadius: '12px !important',
      // height: '100% !important',
    },
    supportTeamName: {
      color: '#FFFFFF !important',
      fontWeight: '500 !important',
      fontSize: '20px !important',
      lineHeight: '28px !important',
      marginLeft: '10px !important',
    },
    supportTeamAvatar: {
      width: '32px',
      height: '32px',
      color: theme.palette.KenColors.ClientBlue7,
      backgroundColor: theme.palette.KenColors.WhiteGray4,
    },
    headerContaine: {
      backgroundColor: '#585A64',
      padding: '10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    closeButton: {
      color: 'white !important',
    },
    chatMessagesContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      maxHeight: '300px',
      overflowY: 'auto',
      '@media (min-width: 1920px) and (max-width: 1940px)': {
        maxHeight: '455px !important',
      },
      '@media (max-width:626px)': {
        maxHeight: '400px !important',
      },
    },
    chatMessageAdmin: {
      backgroundColor: '#F6F8FB !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      // marginTop: theme.spacing(2),
      maxWidth: '70%',
    },
    chatMessageAdminname: {
      maxWidth: '70%',
    },
    chatMessageUser: {
      backgroundColor: '#EAEFFF !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignSelf: 'flex-end',
      maxWidth: '70%',
    },
    chatMessageUsername: {

      alignSelf: 'flex-end',
      maxWidth: '70%',
    },
    replyButton: {
      marginLeft: 'auto',
      marginRight: theme.spacing(2),
    },
    messageInputContainer: {
      display: 'flex',
      alignItems: 'center',
      // borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        minWidth: '300px',
        marginTop: '19vh',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1300, // above the backdrop/dialog
    borderTop: '1px solid #e0e0e0',
  },
    },
    dibtextflex: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #EDEEF1',
      width: '100%',
      padding: '0px 10px',
      borderRadius: '12px',
      backgroundColor: '#EDEEF1',

    },
    messageInput: {
      flex: 1,
      marginRight: theme.spacing(1),
      backgroundColor: '#EDEEF1',
    },
    notchedOutline: {
      border: 'none !important',
    },
    attachFilesIcon: {
      cursor: 'pointer',
    },
    'MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    noBorder: {
      border: 'none !important',
    },
    senderMsg: {
      fontSize: '14px !important',
      fontWeight: '400 !important',
      color: '#333 !important',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '10.5px !important',
      },
    },
    chatMsg: {
      fontSize: '14px !important',
      fontWeight: '400 !important',
      color: '#373A45 !important',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '10.5px !important',
      },
    },

    messageTimeTypo: {
      fontsize: '12px !important',
      fontWeight: '400',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '9px !important',
      },
    },

    dateSeparator: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      fontWeight: '400 !important',
      color: 'rebeccapurple',
    },
    date: {
      border: '1px solid #F0EDF6 !important',
      borderRadius: '12px',
      padding: '2px 10px',
      marginBlock: '4px 6px',
      backgroundColor: '#F0EDF6 !important',
      fontSize: '14px',
      fontWeight: '500',
      opacity: '0.8',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '10.5px',
      },
    },
    messageTime: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      color: 'grey',
    },
    filePreviewContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '10px',
    },
    imagePreview: {
      width: '40px',
      height: '40px',
      objectFit: 'cover',
      borderRadius: '4px',
    },
    fileName: {
      marginLeft: '10px',
      fontSize: '0.875rem',
      color: '#555',
    },
    attachmentContainer: {
      display: 'flex',
      marginTop: '10px',
    },

    attachmentImage: {
      maxWidth: '150px',
      maxHeight: '150px',
      objectFit: 'cover',
    },

    fileLink: {
      marginTop: '5px',
    },
  })
);

export default useStyles;
